import { AppchargeErrorType } from '../contracts';
import { TFunction } from 'i18next';

const ERROR_TYPE_TO_KEY: Record<AppchargeErrorType, string> = {
  [AppchargeErrorType.GENERIC]: 'generic', // Backwards compatibility, remove after sprint 73
  [AppchargeErrorType.INCORRECT_CVC]: 'incorrectCvc', // Backwards compatibility, remove after sprint 73
  [AppchargeErrorType.TIMEOUT]: 'timeout', // Backwards compatibility, remove after sprint 73
  [AppchargeErrorType.EXPIRED_CARD]: 'expiredCard',
  [AppchargeErrorType.CARD_NOT_SUPPORTED]: 'cardNotSupported',
  [AppchargeErrorType.INSUFFICIENT_FUNDS]: 'insufficientFunds',
  [AppchargeErrorType.CONNECTION]: 'connection',
  [AppchargeErrorType.TRANSACTION_NOT_PERMITTED]: 'transactionNotPermitted',
  [AppchargeErrorType.SUSPECT_FRAUD]: 'suspectFraud',
  [AppchargeErrorType.AUTHORIZATION_ERROR]: 'authorizationError',
  [AppchargeErrorType.AUTHENTICATION_REQUIRED]: 'authenticationRequired',
  [AppchargeErrorType.AUTHENTICATION_NOT_HANDLED]: 'authenticationNotHandled',
  [AppchargeErrorType.APPROVE_WITH_ID]: 'approveWithId',
  [AppchargeErrorType.CARD_VELOCITY_EXCEEDED]: 'cardVelocityExceeded',
  [AppchargeErrorType.CURRENCY_NOT_SUPPORTED]: 'currencyNotSupported',
  [AppchargeErrorType.DUPLICATE_TRANSACTION]: 'duplicateTransaction',
  [AppchargeErrorType.GENERIC_DECLINE]: 'genericDecline',
  [AppchargeErrorType.INCORRECT_ADDRESS]: 'incorrectAddress',
  [AppchargeErrorType.INVALID_ZIP]: 'invalidZip',
  [AppchargeErrorType.INVALID_ACCOUNT]: 'invalidAccount',
  [AppchargeErrorType.INVALID_AMOUNT]: 'invalidAmount',
  [AppchargeErrorType.INVALID_CVC]: 'invalidCvc',
  [AppchargeErrorType.INVALID_EXPIRY_DATE]: 'invalidExpiryDate',
  [AppchargeErrorType.INVALID_NUMBER]: 'invalidNumber',
  [AppchargeErrorType.INVALID_PIN]: 'invalidPin',
  [AppchargeErrorType.NOT_PERMITTED]: 'notPermitted',
  [AppchargeErrorType.PIN_TRY_EXCEEDED]: 'pinTryExceeded',
  [AppchargeErrorType.PROCESSING_ERROR]: 'processingError',
  [AppchargeErrorType.REVOCATION_OF_AUTHORIZATION]: 'revocationOfAuthorization',
  [AppchargeErrorType.WITHDRAWAL_COUNT_LIMIT_EXCEEDED]: 'withdrawalCountLimitExceeded',
};

export function generateAppchargeErrorMessage(t: TFunction, appChargeErrorType?: string) {
  const getErrorMessage = (appChargeErrorType: string) => {
    const translationKey =
      ERROR_TYPE_TO_KEY[appChargeErrorType as AppchargeErrorType] ||
      ERROR_TYPE_TO_KEY[AppchargeErrorType.GENERIC];
    return t(`appchargeErrors.${translationKey}`);
  };

  const errorMessage: string = getErrorMessage(appChargeErrorType || AppchargeErrorType.GENERIC);

  return errorMessage;
}
